import { render, staticRenderFns } from "./AllBusinessNameDataUpdateEscalations.vue?vue&type=template&id=3fd5b49c&scoped=true&"
import script from "./AllBusinessNameDataUpdateEscalations.vue?vue&type=script&lang=js&"
export * from "./AllBusinessNameDataUpdateEscalations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd5b49c",
  null
  
)

export default component.exports